import React from "react";
import { Col, Form } from "react-bootstrap";
import CopyToClipboard from "components/Site/SiteView/SiteOverview/Tabs/CopyToClipboard";

const CustomField = React.memo(function CustomField({ field, value, editMode, onChange, showLabel = true, useCol = true, colSizes = {}, maxLength = 50, customStyle = {} }) {
  const fieldName = field?.field_name;

  return (
    <>
    {useCol ?
      <Col
        id={field?.id}
        sm={colSizes?.sm ? colSizes.sm : 12} 
        md={colSizes?.md ? colSizes.md : 6}
        lg={colSizes?.lg ? colSizes.lg : 6}
        className={`detail-field ${useCol && customStyle?.col ? customStyle?.col : ""}`}
      >
        {showLabel &&
          <div className="d-flex flex-row">
            <Form.Label className="form-input-labels">{fieldName}</Form.Label>
            {(!editMode && value) && <CopyToClipboard id={fieldName} copyText={value} />}
          </div>
        }
        <Form.Control
          data-intercom-target={`${fieldName}-input-field`}
          type="text"
          maxLength={maxLength}
          name={`${fieldName}_input`}
          className={`
            ${!editMode ? "site-details-read-only" : "edit-mode"} 
            ${customStyle?.control ? customStyle?.control : ""}
          `}
          value={value ?? ""}
          onChange={(e) => onChange(field, e.target.value)}
        />
      </Col>
    :
      <span>
        {showLabel &&
          <div className="d-flex flex-row">
            <Form.Label className="form-input-labels">{fieldName}</Form.Label>
            {(!editMode && value) && <CopyToClipboard id={fieldName} copyText={value} />}
          </div>
        }
        <Form.Control
          data-intercom-target={`${fieldName}-input-field`}
          type="text"
          maxLength={maxLength}
          name={`${fieldName}_input`}
          className={`
            ${!editMode ? "site-details-read-only" : "edit-mode"} 
            ${customStyle?.control ? customStyle?.control : ""}
          `}
          value={value ?? ""}
          onChange={(e) => onChange(field, e.target.value)}
        />
      </span>
    }
    </>
  );
}, (prevProps, nextProps) => {
  // prevent re-render unless relevant data changes
  return (
    prevProps?.value === nextProps?.value &&
    prevProps?.editMode === nextProps?.editMode &&
    prevProps?.field?.id === nextProps?.field?.id &&
    prevProps?.enableWindowSize === nextProps?.enableWindowSize &&
    prevProps?.customStyle?.col === nextProps?.customStyle?.col &&
    prevProps?.customStyle?.control === nextProps?.customStyle?.control
  );
});

export default CustomField;